import { customerIsCompany } from '@/helpers/customerUtils';
import { trackingThumbsSurvey } from '@/helpers/trackingHelper';
import usePanelParticipation from '@/hooks/usePanelParticipation';
import { State } from '@/types/State';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { CookiebotConsentGuard } from 'ui';
import ThumbsSurvey, { ThumbsSurveyData } from 'ui/components/ThumbsSurvey';
import { getSelectedCustomer } from '../../app/slices/userSlice';
import PanelInvite from './PanelInvite';
import { SurveyOptions } from '@/features/routes/types';
import { Box } from 'ui/mui';
import { useSurvey } from '@/context/SurveyContext';

type ThumbsSurveyPanelProps = {
  surveyOptions?: SurveyOptions;
};

const ThumbsSurveyPanel = ({ surveyOptions }: ThumbsSurveyPanelProps) => {
  const surveyContext = useSurvey();
  const selectedCustomer = useSelector((state: State) =>
    getSelectedCustomer(state),
  );

  const [panelFormFinished, setPanelFormFinished] = useState(false);
  const [showPanelInvite, setShowPanelInvite] = useState(false);

  const { data: panelParticipationStatus } = usePanelParticipation();

  if (surveyOptions?.hide) {
    return null;
  }

  const pageLoaded = surveyContext?.pageLoaded ?? true;

  if (!pageLoaded) {
    return null;
  }

  const onThumbSubmit = (data: ThumbsSurveyData) => {
    //If user is on landing page and has selected new landing page, set page_variant to 'new'
    if (
      selectedCustomer?.useNewLandingPage &&
      window.location.pathname === '/'
    ) {
      data.page_variant = 'new';
    }
    trackingThumbsSurvey(data);
    if (!panelParticipationStatus) {
      setShowPanelInvite(true);
    }
  };

  return (
    <CookiebotConsentGuard>
      <Box sx={{ mt: 4 }}>
        {!panelFormFinished && (
          <ThumbsSurvey
            data-clarity-unmask='True'
            thumbUpLabel={surveyOptions?.thumbUpLabel}
            thumbDownLabel={surveyOptions?.thumbDownLabel}
            label={
              surveyOptions ? surveyOptions.label : `Vad tycker du om sidan?`
            }
            onSubmit={onThumbSubmit}
          />
        )}

        {showPanelInvite && !customerIsCompany(selectedCustomer) && (
          <PanelInvite
            setPanelFormFinished={setPanelFormFinished}
            panelFormFinished={panelFormFinished}
          />
        )}
      </Box>
    </CookiebotConsentGuard>
  );
};
export default ThumbsSurveyPanel;
